import { useSelector } from "react-redux";
import { shallowEqual } from "react-redux";

const normalizeRoles = (roles) => {
  const values = Array.isArray(roles) ? roles : roles ? [roles] : [];
  return [...new Set(values
    .map((role) => typeof role === "object"
      ? role?.name || role?.value || role?.role || role?.userRole
      : role)
    .map((role) => String(role || "").trim().toUpperCase().replace(/^ROLE_/, ""))
    .filter(Boolean))];
};

export const selectAuthSession = (state) => {
  const auth = state?.auth || {};
  const user = auth.data || auth.user || auth.userInfo || null;
  const userInfo = auth.userInfo || auth.data || auth.user || null;

  return {
    isAuthenticated: auth.isAuthenticated === true,
    isLoggedIn: auth.isLoggedIn === true,
    isLoggingOut: auth.isLoggingOut === true,
    logoutReason: auth.logoutReason || null,
    user,
    userInfo,
    roles: normalizeRoles(auth.userRoles || user?.userRoles || user?.roles || user?.userRole),
  };
};

export const useAuthSession = () => useSelector(selectAuthSession, shallowEqual);

export const getAuthSession = (state) => selectAuthSession(state);

export default useAuthSession;
